<div style="padding: 0 24px 64px 24px">
    <kiene-page-header [ueberschrift]="'Meine Händler'"></kiene-page-header>

    <div>
        <h3>Übersicht</h3>
        <kiene-haendler-favoriten #favoriten></kiene-haendler-favoriten>
    </div>
</div>
